module.exports = __webpack_public_path__ + "static/netflix-tudum-4-6f57319b5ebbcdd6b5ac17ee1ae90d4c.jpg";